<template>
<div
    v-if="value != null"
>
    <div
        style="display: flex; gap: 15px;"
    >
        <div
            v-if="value.value.type == 'rgba'"
            style="flex-grow: 0px; width: 55px; height: 55px; position: relative; border: 1px solid rgba(0,0,0,0.3);"
        >
            <div
                class="checker"
            />

            <div
                class="swatch"
                :style="style_color_swatch"
            />
        </div>
    
        <v-text-field
            :label="value.name"
            :value="value.value.raw_value"
            readonly
        >
            <span
                slot="append-outer"
                style="display: flex; gap: 8px; align-items: center;"
            >
                <v-icon
                    v-on:click="onClickEdit"
                    color="primary"
                    style="pointer-events: auto;"
                >
                    mdi-lead-pencil
                </v-icon>
                <v-icon
                    v-on:click="onClickDelete"
                    color="error"
                    style="pointer-events: auto;"
                    small
                >
                    mdi-delete
                </v-icon>
            </span>
        </v-text-field>

        <m-edit-css-property-dialog
            ref="edit-css-property-dialog"
            v-on:modify="$emit('modify', $event)"
        />

    </div>

</div>
</template>

<script>
export default {
    props: {

        value: {
            type: Object,
            default: function() { return null; }
        },
    },

    data() {
        return {
        }
    },

    methods: {
        
        onClickEdit()
        {
            this.$refs['edit-css-property-dialog'].showDialog({
                'label': this.value.name,
                'value': this.value
            });
        },

        onClickDelete()
        {
            this.$rc.confirm({
                'title': 'Remove CSS Property',
                'body': `Remove the "${this.value.name}" property?<br/><br/>This cannot be undone.`,
                'btn_text_ok': 'Remove',
                'btn_text_cancel': 'Cancel',
                'on_ok': () => {
                    this.$emit('modify', {
                        'op': 'delete',
                        'property_name': this.value.name
                    });
                },
            });
        },
    },

    computed: {
        style_color_swatch() {
            return 'background-color: '+this.value.value.raw_value;
        }
    },
}
</script>

<style lang="scss" scoped>
.checker
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;
    
    background-image: url('https://files.redchirp.com/dcf69ef7-2e39-4bcd-b0ca-cd4be32eeff2.webp'); 
    background-size: cover; 
    background-position: center;
    background-repeat: no-repeat;

    z-index: 1;
}

.swatch
{
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    z-index: 2;
}

</style>